export default __webpack_public_path__ + "static/media/fbIcon.5b241308.PNG";